/** Demo systems matching the Complaint Management design (used when no data is passed). */
export const DEMO_SYSTEMS = [
  {
    id: 'qms',
    title: 'QMS - Query Management System',
    status: 'active',
    description: 'Description of the template',
    departments: 3,
    workflows: 12,
    fields: 55,
    formsFilled: 234,
    updatedOn: '12 Mar 2024',
    titleAsLink: false,
  },
  {
    id: 'cms',
    title: 'CX- Pulse-360 ',
    status: 'active',
    description: 'Description of the template',
    departments: 5,
    workflows: 8,
    fields: 42,
    formsFilled: 189,
    updatedOn: '08 Mar 2024',
  },
  {
    id: 'fms',
    title: 'ENE - TRACKER',
    status: 'inactive',
    description: 'Description of the template',
    departments: 2,
    workflows: 4,
    fields: 28,
    formsFilled: 56,
    updatedOn: '01 Feb 2024',
  },
  {
    id: 'rms',
    title: 'RTV - Return to Vendor ',
    status: 'active',
    description: 'Description of the template',
    departments: 4,
    workflows: 10,
    fields: 61,
    formsFilled: 312,
    updatedOn: '20 Mar 2024',
  },
];

export const DEFAULT_PAGE_DESCRIPTION =
  'Create, manage and track complaint forms, workflows and responses across departments.';
